// @flow
import React from 'react';

import CampaignButton from './CampaignButton';

const playUpUrl = 'https://www.playup.com.au';

const BetWithPlayUp = () => (
  <CampaignButton icon="icon_menu_playup" onClick={() => window.open(playUpUrl, '_blank')}>
    BET WITH PLAYUP
  </CampaignButton>
);

export default BetWithPlayUp;
